"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMac = exports.evil = exports.request = exports.Utils = exports.isNumberStr = exports.isNumber = exports.generateId = exports.getTranslate = exports.getLocale = void 0;
/**
 * 工具类，提供给本库使用，也可以提供给其他库使用
 *
 * @author sunny
 * @date 2019-09
 */
var Utils_1 = require("./Utils");
exports.Utils = Utils_1.default;
var Request_1 = require("./Request");
exports.request = Request_1.default;
/**
 * 判断一个值是否是数值
 * @function
 *
 * @param {any} value
 * @returns {boolean}
 */
var isNumber = function (value) {
    return typeof value === "number";
};
exports.isNumber = isNumber;
/**
 * 字符串是否是数值的字符串形式
 * @function
 *
 * @param {string} val
 * @returns {boolean}
 */
function isNumberStr(val) {
    return /^[-|+]?[\d|\\.]+$/.test(val);
}
exports.isNumberStr = isNumberStr;
/**
 * 执行一个字符串定义的函数
 * @function
 *
 * @param fn 函数字符串
 * @returns {any}
 */
function evil(fn) {
    var Fn = Function; //一个变量指向Function，防止有些前端编译工具报错
    return new Fn("return " + fn)();
}
exports.evil = evil;
/**
 * 判断当前系统是否是Mac系统 (通过浏览器的user-agent)
 * @function
 *
 * @returns {boolean}
 */
function isMac() {
    return /Macintosh/g.test(navigator.userAgent);
}
exports.isMac = isMac;
function getLocale() {
    var locale = window.locale;
    if (!locale) {
        if (localStorage.getItem("locale")) {
            locale = localStorage.getItem("locale");
        }
        if (!locale) {
            locale = "zh-CN";
        }
    }
    return locale;
}
exports.getLocale = getLocale;
/**
 * UI翻译函数
 *
 * UI的翻译内容是一个对象，格式如下：
 * {
 *  "en": {
 *    "a": "A",
 *    "b": "B",
 *  }
 * }
 *
 * 对象默认存储在 window.langMaps 对象中，如果没有，则使用原始内容
 *
 * 当前设置语言可以通过 window.locale 设置，默认为 zh-CN
 *
 * @param locale 语言-区域代码: zh-CN, en-US，如果传入null，则使用当前设置的语言
 * @param key 翻译内容
 * @returns
 */
function getTranslate(locale, key) {
    if (!key)
        return "";
    var langMaps = window.langMaps;
    if (langMaps) {
        if (!locale) {
            locale = getLocale();
        }
        if (langMaps[locale]) {
            return langMaps[locale][key] || key;
        }
    }
    return key;
}
exports.getTranslate = getTranslate;
var generateId = function (num) {
    if (num === void 0) { num = 32; }
    var map = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
    ];
    var arr = [];
    while (num--) {
        var rand = Math.floor(Math.random() * 16);
        arr.push(map[rand]);
    }
    return arr.join('');
};
exports.generateId = generateId;
